define.alias("shared/components/shared/ai-credits/info", "preview-grid/components/shared/ai-credits/info");